import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.0-canary.55_@babel+core@7.27.4_react-dom@19.0.0_react@19.0.0__react@19.0.0_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/onborda@1.2.5_@radix-ui+react-portal@1.1.9_@types+react-dom@19.0.1_@types+react@19.0.1__97e2458831edad1ea0f8370da12f5336/node_modules/onborda/dist/Onborda.js");
;
import(/* webpackMode: "eager", webpackExports: ["OnbordaProvider","useOnborda"] */ "/app/node_modules/.pnpm/onborda@1.2.5_@radix-ui+react-portal@1.1.9_@types+react-dom@19.0.1_@types+react@19.0.1__97e2458831edad1ea0f8370da12f5336/node_modules/onborda/dist/OnbordaContext.js");
;
import(/* webpackMode: "eager" */ "/app/public/brand/kampmann-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/socialmedia/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/socialmedia/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/socialmedia/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/socialmedia/xing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icons/socialmedia/youtube.svg");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbComponent"] */ "/app/src/components/custom/breadcrumb/breadcrumbComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TourCard"] */ "/app/src/components/custom/cards/TourCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderComponent"] */ "/app/src/components/custom/header/headerComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlagsContextProvider"] */ "/app/src/contexts/FlagsContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/contexts/TranslationContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/lib/logging/client-logging.ts");
